export default "__VITE_ASSET__DzvD$kUC__"